/**
 * Políticas comerciales del simulador (frontend only).
 * El tenant se elige con REACT_APP_COMMERCIAL_SIMULATOR_POLICY.
 * La visibilidad se controla con REACT_APP_ENABLE_COMMERCIAL_SIMULATOR.
 * La fórmula vive en src/utils/commercialSimulator.js.
 */
export const commercialSimulatorPolicies = {
  mpsa: {
    iva: 0.21,
    installments: {
      min: 4,
      max: 18,
    },
    products: {
      moto: {
        name: 'Moto',
        max_amount: 3000000,
      },
      hogar: {
        name: 'Hogar',
        max_amount: 1500000,
      },
    },
    modalities: {
      first_installment_advance: {
        name: '1er cuota adelantada',
        tna: 0.4,
        capital_percentage: 1,
      },
      capital_advance_20: {
        name: 'Oferta Especial (100% Financiado)',
        tna: 0.42,
        capital_percentage: 1,
      },
      normal: {
        name: 'Normal',
        tna: 0.49,
        capital_percentage: 1,
      },
    },
  },
};

export function getCommercialSimulatorPolicyKey() {
  return String(process.env.REACT_APP_COMMERCIAL_SIMULATOR_POLICY || '')
    .trim()
    .toLowerCase();
}

export function getCommercialSimulatorPolicy(
  key = getCommercialSimulatorPolicyKey()
) {
  return commercialSimulatorPolicies[key] || null;
}

export function isCommercialSimulatorEnabled() {
  return (
    process.env.REACT_APP_ENABLE_COMMERCIAL_SIMULATOR === 'true' &&
    Boolean(getCommercialSimulatorPolicy())
  );
}
